import type { ReactNode } from "react";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { VariantItem } from "./playgroundControls";
import styles from "./MenuPlayground.module.scss";

/** A menu forced open under a small trigger, in a cell tall enough for its popup. */
export const OpenMenuCell = ({
    label,
    children,
}: {
    label: string;
    children: ReactNode;
}) => (
    <VariantItem label={label}>
        <div className={styles.openCell}>
            <Menu.Root
                open
                trigger={
                    <Button variant="secondary" size="sm">
                        Menu
                    </Button>
                }
            >
                {children}
            </Menu.Root>
        </div>
    </VariantItem>
);
